// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const RUNNER_ACTIONS_KEY = {
  TRIGGER_SAGA_CREATE_RUNNER: 'TRIGGER_SAGA_CREATE_RUNNER',
  TRIGGER_SAGA_STOP_RUNNER: 'TRIGGER_SAGA_STOP_RUNNER',
};
